import React, { Component } from "react";

import { connect } from "react-redux";

import searchicon from "../../assets/images/Managebooks/searchicon.svg";
import Polygon from "../../assets/images/Managebooks/Polygon.svg";
import tableBook from "../../assets/images/Managebooks/tableBook.svg";
import plus from "../../assets/images/Managebooks/plus.png";
import printIcon from "../../assets/images/Managebooks/print.png";
import DataTablePaperback from "../../components/DataTable/DataTablePaperback";
import { Dropdown, Modal, Form, DropdownButton } from "react-bootstrap";
import { Box, Tabs, Tab } from "@mui/material";

import moment from "moment";
import Moment from "react-moment";
import CloseIcon from "../../assets/images/purchasehistory/PrintModal/close.png";
import PlaceHolder from "../../assets/images/purchasehistory/PlaceHolder.png";

import {
  getAllPaperbackOrders,
  createPaymentOfOrder,
  updatePaperbackOrderDelivery,
} from "../../store/actions/orderAction";
import LottieAnimation from "../../components/LottieAnimation/LottieAnimation";

var cx = require("classnames");

class SellingHistoryPaperback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderList: [],
      errors: [],
      serverError: {},
      isLoading: false,
      sortByName: false,
      sortByDate: false,
      sortByStatus: false,
      sortByReference: false,
      sortByPrice: false,
      search: "",
      totalearning: "",
      pendingTotal: "",
      dayEarning: "",
      dayPending: "",
      PrintModal: false,
      ReferenceModal: false,
      author: {},
      Reference_No: "",
      Status: "",
      Amount: "",
      index: {},
      currentPage: 1,
      todosPerPage: 15,
      isUploading: false,
      OrderListFiltered: [],
      fromDate: "2021-05-01T01:10:00Z",
      toDate: "2021-10-01T01:10:00Z",
      earning: 0,
      clearedBills: 0,
      isLoading: true,
      clearingAmountLabel: '',
      activeTab: 0,
      CongratulationModal: false,
      trackingModal: false,
      selectedOrderForTracking: null,
      tracking_id: ""
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot) { }

  componentDidMount() {
    this.props
      .getAllPaperbackOrders()
      .then((res) => {
        console.log('Response', res);
        // API returns { status: true, content: [...] } structure
        // New structure: each order has { Order_ID, order: {...}, items: [...] }
        if (res.status && res.content) {
          const orders = res.content || [];
          
          // Group orders by Order_ID - one row per order with all items
          const groupedOrderList = [];
          orders.forEach(order => {
            if (order.items && Array.isArray(order.items) && order.items.length > 0) {
              // Create a grouped order object with all items
              groupedOrderList.push({
                Order_ID: order.Order_ID,
                order: order.order,
                paperback_order: order.order, // Keep for backward compatibility
                items: order.items, // Store all items for this order
                // Use first item's data for main row display
                ...order.items[0],
                createdAt: order.order?.createdAt || order.items[0]?.createdAt,
                updatedAt: order.order?.updatedAt || order.items[0]?.updatedAt,
                // Calculate total amount for all items
                totalBookAmount: order.items.reduce((sum, item) => {
                  const price = parseFloat(item?.paperback?.Price || item?.book?.Price || 0);
                  const quantity = parseInt(item?.quantity || 1);
                  return sum + (price * quantity);
                }, 0)
              });
            }
          });
          
          this.setState(
            {
              orderList: groupedOrderList,
            },
            () => {
              this.getTotalEarning(groupedOrderList);
              this.setState({
                ["SORT" + "createdAt"]: "DESC",
                isLoading: false,
              });
              let { orderList, OrderListFiltered } = this.state;
              let orderListSorted = orderList.sort(
                this.sortArrByOrder("createdAt", "DESC")
              );
              let OrderListFilteredSorted = OrderListFiltered.sort(
                this.sortArrByOrder("createdAt", "DESC")
              );
              this.setState({
                orderList: orderListSorted,
                OrderListFiltered: OrderListFilteredSorted,
              });
            }
          );
        } else {
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isLoading: false });
      });
  }

  onPayment = (item) => {
    console.log('Pressed')
    var addBookData = {
      Order_ID: item?.Order_ID,
      Book_ID: item?.Book_ID,
      Status: this.state.Status,
      Reference_No: this.state.Reference_No,
      clearingAmount: this.state.Amount,
    };
    this.setState({ isUploading: true });

    this.props
      .createPaymentOfOrder(addBookData)
      .then((res) => {
        console.log('Response of Create Payment', res.status);
        if (res.status) {
          console.log(res);

          this.props
            .getAllPaperbackOrders()
            .then((res) => {
              if (res.status && res.content) {
                const orders = res.content || [];
                
                // Flatten the structure
                // Group orders by Order_ID
                const groupedOrderList = [];
                orders.forEach(order => {
                  if (order.items && Array.isArray(order.items) && order.items.length > 0) {
                    groupedOrderList.push({
                      Order_ID: order.Order_ID,
                      order: order.order,
                      paperback_order: order.order,
                      items: order.items,
                      ...order.items[0],
                      createdAt: order.order?.createdAt || order.items[0]?.createdAt,
                      updatedAt: order.order?.updatedAt || order.items[0]?.updatedAt,
                      totalBookAmount: order.items.reduce((sum, item) => {
                        const price = parseFloat(item?.paperback?.Price || item?.book?.Price || 0);
                        const quantity = parseInt(item?.quantity || 1);
                        return sum + (price * quantity);
                      }, 0)
                    });
                  }
                });
                
                this.setState({
                  orderList: groupedOrderList,
                  ReferenceModal: false,
                  isUploading: false,
                }, () => {
                  console.log('Updated List', this.state.orderList);
                  this.getTotalEarning(groupedOrderList);
                  this.setState({
                    ["SORT" + "createdAt"]: "DESC",
                    isLoading: false,
                  });
                  let { orderList, OrderListFiltered } = this.state;
                  let orderListSorted = orderList.sort(
                    this.sortArrByOrder("createdAt", "DESC")
                  );
                  let OrderListFilteredSorted = OrderListFiltered.sort(
                    this.sortArrByOrder("createdAt", "DESC")
                  );
                  this.setState({
                    orderList: orderListSorted,
                    OrderListFiltered: OrderListFilteredSorted,
                  });
                });
              } else {
                this.setState({ isUploading: false });
              }
            })
            .catch((err) => {
              console.log(err);
              this.setState({ isUploading: false });
            });
        }
      })
      .catch((err) => {
        var validationError = [];
        var serverError = [];
        this.setState({ isUploading: false });

        console.log(err.hasOwnProperty("validation"));
        if (err.hasOwnProperty("validation")) {
          err.validation.map((obj) => {
            if (obj.hasOwnProperty("param")) {
              validationError[obj["param"]] = obj["msg"];
            } else {
              serverError = [...serverError, obj];
            }
          });
          this.setState({ errors: validationError });
          this.setState({ serverError: serverError });
        } else {
          this.setState({ serverError: [{ msg: "server not responding" }] });
        }
      });
  };

  onChangeText = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value }, () => {
      this.onSearch(e.target.value);
    });
  };

  onClickFailed = () => {
    let { orderList } = this.state;
    let fiteredList = orderList.filter((item) => item?.order_book?.Payment_Status === "Failed")
    this.setState({
      currentPage: 1,
    });
    this.setState({ OrderListFiltered: fiteredList });
  }
  
  onSearch = async (searchStr) => {
    if (!searchStr) {
      this.setState({ OrderListFiltered: [] });
      return;
    }
    let { orderList } = this.state;
    let fiteredList = orderList.filter((item) => {
      if (
        item?.paperback?.Name?.toLowerCase().includes(searchStr.toLowerCase()) ||
        item?.order?.Payment_Method?.toLowerCase().includes(
          searchStr.toLowerCase()
        ) ||
        item?.paperback_order?.Payment_Method?.toLowerCase().includes(
          searchStr.toLowerCase()
        ) ||
        item?.Order_ID?.toLowerCase().includes(searchStr.toLowerCase())
      )
        return true;
      return false;
    });
    this.setState({
      currentPage: 1,
    });
    this.setState({ OrderListFiltered: fiteredList });
  };
  
  onClickActions = (item) => {
    console.log(item)
    // Check if this is a paperback order
    const isPaperback = item?.type === 'paperback' || item?.type === 'PAPERBACK' || item?.paperback !== undefined;
    
    let calculatedAmount, clearingAmountLabel;
    
    if (isPaperback) {
      // Paperback orders - only PKR, no USD
      const bookPrice = parseFloat(item?.paperback?.Price || item?.book?.Price || 0);
      calculatedAmount = bookPrice * 0.7;
      clearingAmountLabel = ''; // No USD conversion needed
    } else {
      // Ebook orders - existing logic
      calculatedAmount = item.order_book?.currency == 'PKR' ? item.bookAmount * 0.7 : (item.bookAmount * item.order_book?.dollarRate) * 0.7;
      clearingAmountLabel = item.order_book?.currency == 'PKR' ? '' : `${item.bookAmount}$ - 30% TLBC Commision = ${item.clearingAmount}$ (${item.clearingAmount} * ${item.order_book?.dollarRate} CR)`;
    }
    
    this.setState({
      ReferenceModal: true,
      index: item,
      Amount: calculatedAmount,
      clearingAmountLabel: clearingAmountLabel
    }, () => console.log('Clicked Item', item))
  }

  onUpdateDeliveryStatus = (item, newStatus) => {
    console.log('Updating delivery status:', { item, newStatus });
    
    // If status is Dispatched, open modal to get tracking ID
    if (newStatus === 'Dispatched') {
      this.setState({
        trackingModal: true,
        selectedOrderForTracking: item,
        tracking_id: ""
      });
      return;
    }
    
    // For other statuses, update directly without tracking ID
    const orderData = {
      ID: item.ID,
      Order_ID: item.Order_ID,
      Status: newStatus
    };

    console.log('Sending order data:', orderData);

    this.props
      .updatePaperbackOrderDelivery(orderData)
      .then((res) => {
        console.log('Delivery status update response:', res);
        // API returns { data: { msg: "...", Status: "..." } }
        if (res && (res.data || res.msg)) {
          // Show success message
          alert(res.data?.msg || res.msg || 'Status updated successfully');
          
          // Refresh the order list
          this.props
            .getAllPaperbackOrders()
            .then((res) => {
              console.log('Refreshed order list:', res);
              if (res.status && res.content) {
                const orders = res.content || [];
                
                // Flatten the structure
                // Group orders by Order_ID
                const groupedOrderList = [];
                orders.forEach(order => {
                  if (order.items && Array.isArray(order.items) && order.items.length > 0) {
                    groupedOrderList.push({
                      Order_ID: order.Order_ID,
                      order: order.order,
                      paperback_order: order.order,
                      items: order.items,
                      ...order.items[0],
                      createdAt: order.order?.createdAt || order.items[0]?.createdAt,
                      updatedAt: order.order?.updatedAt || order.items[0]?.updatedAt,
                      totalBookAmount: order.items.reduce((sum, item) => {
                        const price = parseFloat(item?.paperback?.Price || item?.book?.Price || 0);
                        const quantity = parseInt(item?.quantity || 1);
                        return sum + (price * quantity);
                      }, 0)
                    });
                  }
                });
                
                this.setState({
                  orderList: groupedOrderList,
                }, () => {
                  let { orderList, OrderListFiltered } = this.state;
                  let orderListSorted = orderList.sort(
                    this.sortArrByOrder("createdAt", "DESC")
                  );
                  let OrderListFilteredSorted = OrderListFiltered.sort(
                    this.sortArrByOrder("createdAt", "DESC")
                  );
                  this.setState({
                    orderList: orderListSorted,
                    OrderListFiltered: OrderListFilteredSorted,
                  });
                  console.log('Order list updated in state');
                });
              } else {
                console.log('No content in response:', res);
              }
            })
            .catch((err) => {
              console.log('Error refreshing order list:', err);
            });
        } else {
          console.log('Unexpected response format:', res);
          // Still refresh the list even if response format is unexpected
          this.props
            .getAllPaperbackOrders()
            .then((res) => {
              if (res.status && res.content) {
                const orders = res.content || [];
                
                // Group orders by Order_ID
                const groupedOrderList = [];
                orders.forEach(order => {
                  if (order.items && Array.isArray(order.items) && order.items.length > 0) {
                    groupedOrderList.push({
                      Order_ID: order.Order_ID,
                      order: order.order,
                      paperback_order: order.order,
                      items: order.items,
                      ...order.items[0],
                      createdAt: order.order?.createdAt || order.items[0]?.createdAt,
                      updatedAt: order.order?.updatedAt || order.items[0]?.updatedAt,
                      totalBookAmount: order.items.reduce((sum, item) => {
                        const price = parseFloat(item?.paperback?.Price || item?.book?.Price || 0);
                        const quantity = parseInt(item?.quantity || 1);
                        return sum + (price * quantity);
                      }, 0)
                    });
                  }
                });
                
                this.setState({ orderList: groupedOrderList });
              }
            });
        }
      })
      .catch((err) => {
        console.log('Error updating delivery status:', err);
        if (err.validation) {
          alert('Validation error: ' + JSON.stringify(err.validation));
        } else if (err.msg) {
          alert(err.msg);
        } else if (err.response && err.response.data) {
          alert(err.response.data.msg || 'Failed to update delivery status');
        } else {
          alert('Failed to update delivery status. Please try again.');
        }
      });
  }

  handleTrackingIdSubmit = () => {
    const { selectedOrderForTracking, tracking_id } = this.state;
    
    if (!tracking_id || tracking_id.trim() === '') {
      alert('Please enter tracking ID');
      return;
    }
    
    if (!selectedOrderForTracking) {
      alert('Order information missing');
      return;
    }
    
    const orderData = {
      ID: selectedOrderForTracking.ID,
      Order_ID: selectedOrderForTracking.Order_ID,
      Status: 'Dispatched',
      tracking_id: tracking_id.trim()
    };

    console.log('Sending order data with tracking ID:', orderData);

    this.props
      .updatePaperbackOrderDelivery(orderData)
      .then((res) => {
        console.log('Delivery status update response:', res);
        // API returns { status: true, content: { msg: "...", Status: "..." } }
        if (res && res.status && res.content) {
          // Close modal immediately on success
          this.setState({
            trackingModal: false,
            selectedOrderForTracking: null,
            tracking_id: ""
          });
          
          // Show success message
          alert(res.content?.msg || 'Order dispatched successfully');
          
          // Refresh the order list to update status on panel
          this.props
            .getAllPaperbackOrders()
            .then((res) => {
              console.log('Refreshed order list:', res);
              if (res.status && res.content) {
                const orders = res.content || [];
                
                // Flatten the structure
                // Group orders by Order_ID
                const groupedOrderList = [];
                orders.forEach(order => {
                  if (order.items && Array.isArray(order.items) && order.items.length > 0) {
                    groupedOrderList.push({
                      Order_ID: order.Order_ID,
                      order: order.order,
                      paperback_order: order.order,
                      items: order.items,
                      ...order.items[0],
                      createdAt: order.order?.createdAt || order.items[0]?.createdAt,
                      updatedAt: order.order?.updatedAt || order.items[0]?.updatedAt,
                      totalBookAmount: order.items.reduce((sum, item) => {
                        const price = parseFloat(item?.paperback?.Price || item?.book?.Price || 0);
                        const quantity = parseInt(item?.quantity || 1);
                        return sum + (price * quantity);
                      }, 0)
                    });
                  }
                });
                
                this.setState({
                  orderList: groupedOrderList,
                }, () => {
                  let { orderList, OrderListFiltered } = this.state;
                  let orderListSorted = orderList.sort(
                    this.sortArrByOrder("createdAt", "DESC")
                  );
                  let OrderListFilteredSorted = OrderListFiltered.sort(
                    this.sortArrByOrder("createdAt", "DESC")
                  );
                  this.setState({
                    orderList: orderListSorted,
                    OrderListFiltered: OrderListFilteredSorted,
                  });
                });
              }
            })
            .catch((err) => {
              console.log('Error refreshing order list:', err);
            });
        } else {
          // Handle unexpected response format
          this.setState({
            trackingModal: false,
            selectedOrderForTracking: null,
            tracking_id: ""
          });
          // Still refresh the list
          this.props
            .getAllPaperbackOrders()
            .then((res) => {
              if (res.status && res.content) {
                const orders = res.content || [];
                
                // Group orders by Order_ID
                const groupedOrderList = [];
                orders.forEach(order => {
                  if (order.items && Array.isArray(order.items) && order.items.length > 0) {
                    groupedOrderList.push({
                      Order_ID: order.Order_ID,
                      order: order.order,
                      paperback_order: order.order,
                      items: order.items,
                      ...order.items[0],
                      createdAt: order.order?.createdAt || order.items[0]?.createdAt,
                      updatedAt: order.order?.updatedAt || order.items[0]?.updatedAt,
                      totalBookAmount: order.items.reduce((sum, item) => {
                        const price = parseFloat(item?.paperback?.Price || item?.book?.Price || 0);
                        const quantity = parseInt(item?.quantity || 1);
                        return sum + (price * quantity);
                      }, 0)
                    });
                  }
                });
                
                this.setState({ orderList: groupedOrderList });
              }
            });
        }
      })
      .catch((err) => {
        console.log('Error updating delivery status', err);
        if (err.validation) {
          alert('Validation error: ' + JSON.stringify(err.validation));
        } else if (err.msg) {
          alert(err.msg);
        } else if (err.response && err.response.data) {
          alert(err.response.data.msg || 'Failed to update delivery status');
        } else {
          alert('Failed to update delivery status. Please try again.');
        }
      });
  }

  handleTrackingModalClose = () => {
    this.setState({
      trackingModal: false,
      selectedOrderForTracking: null,
      tracking_id: ""
    });
  }
  
  handleTabChange = (event, newValue) => {
    this.setState({
      activeTab: newValue,
      currentPage: 1 // Reset to first page when changing tabs
    });
  };
  
  handleClick = (type) => {
    if (type === "next") {
      this.setState({
        currentPage: this.state.currentPage + 1,
      });
    } else if (type === "previous") {
      this.setState({
        currentPage: this.state.currentPage - 1,
      });
    }
  };

  getTotalEarning = (list) => {
    console.log('LIST', list)
    if (list.length > 0) {
      var earning = 0;
      var clearedBills = 0;

      for (var i = 0; i < list.length; i++) {
        // Check if this is a paperback order
        const isPaperback = list[i]?.type === 'paperback' || list[i]?.type === 'PAPERBACK' || list[i]?.paperback !== undefined;
        const isGroupedOrder = list[i]?.items && Array.isArray(list[i].items) && list[i].items.length > 1;
        
        if (isPaperback) {
          // Paperback orders - only PKR, no USD conversion
          let bookPrice = 0;
          
          if (isGroupedOrder) {
            // For grouped orders, sum all items
            bookPrice = list[i].totalBookAmount || list[i].items.reduce((sum, item) => {
              const price = parseFloat(item?.paperback?.Price || item?.book?.Price || 0);
              const quantity = parseInt(item?.quantity || 1);
              return sum + (price * quantity);
            }, 0);
          } else {
            bookPrice = parseFloat(list[i]?.paperback?.Price || list[i]?.book?.Price || 0);
          }
          
          if (list[i].Status == 'Cleared' && list[i].Reference_No !== null) {
            clearedBills = clearedBills + parseInt(list[i].clearingAmount || 0);
          }
          
          earning = earning + parseInt(bookPrice || 0);
        } else {
          // Ebook orders - existing logic with currency conversion
          if (list[i].Status == 'Cleared' && list[i].Reference_No !== null) {
            if (list[i].order_book?.currency == 'PKR') {
              clearedBills = clearedBills + parseInt(list[i].clearingAmount || 0);
            } else {
              clearedBills = clearedBills + parseInt((list[i].clearingAmount || 0) * (list[i].order_book?.dollarRate || 1));
            }
          }

          if (list[i].order_book?.currency == 'PKR') {
            earning = earning + parseInt(list[i].bookAmount || 0);
          } else {
            earning = earning + parseInt((list[i].bookAmount || 0) * (list[i].order_book?.dollarRate || 1));
          }
        }
      }

      console.log('My Earning : ', earning)
      console.log('Cleared Bills : ', clearedBills)

      this.setState({ earning: earning, clearedBills: clearedBills });
    }
  };

  getValue = (item, prop) => {
    switch (prop) {
      case "createdAt":
        return item?.order?.createdAt || item?.paperback_order?.createdAt || item?.order_book?.createdAt || item.createdAt;
      default:
        return item[prop];
    }
  };

  sortArrByOrder = (prop, order) => {
    if (order === "ASC")
      return (a, b) => {
        if (this.getValue(a, prop) > this.getValue(b, prop)) {
          return 1;
        } else if (this.getValue(a, prop) < this.getValue(b, prop)) {
          return -1;
        }
        return 0;
      };

    return (a, b) => {
      if (this.getValue(a, prop) < this.getValue(b, prop)) {
        return 1;
      } else if (this.getValue(a, prop) > this.getValue(b, prop)) {
        return -1;
      }
      return 0;
    };
  };

  getBetweenDate = () => {
    const { orderList, OrderListFiltered, fromDate, toDate } = this.state;
    let start = new Date(fromDate).getTime();
    let end = new Date(toDate).getTime();
    console.log(orderList);

    var orderListSorted = orderList.filter((d) => {
      var time = new Date(d?.order?.createdAt || d?.paperback_order?.createdAt || d?.order_book?.createdAt || d.createdAt).getTime();
      return start < time && time < end;
    });
    var OrderListFilteredSorted = OrderListFiltered.filter((d) => {
      var time = new Date(d?.order?.createdAt || d?.paperback_order?.createdAt || d?.order_book?.createdAt || d.createdAt).getTime();
      return start < time && time < end;
    });
    console.log("betweenList", orderListSorted);
    this.setState({
      orderList: orderListSorted,
      OrderListFiltered: OrderListFilteredSorted,
    });
  };

  handleChange(event) {
    if (event.target.value == 1) {
      this.setState({ CongratulationModal: !this.state.CongratulationModal });
    }
  }

  render() {
    const {
      isLoading,
      orderList,
      currentPage,
      todosPerPage,
      OrderListFiltered,
      activeTab
    } = this.state;
    const { errors } = this.state;

    if (isLoading) {
      return (
        <LottieAnimation />
      );
    }

    // Filter orders - show all paperback orders
    let filteredOrderList = this.state.search ? OrderListFiltered : orderList;

    let printList = filteredOrderList;

    const indexOfLastTodo = currentPage * todosPerPage;
    const indexOfFirstTodo = indexOfLastTodo - todosPerPage;
    const currentTodos = printList.slice(indexOfFirstTodo, indexOfLastTodo);

    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(printList.length / todosPerPage); i++) {
      pageNumbers.push(i);
    }

    return (
      <div>
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <Modal
            dialogClassName="col-xl-12 "
            show={this.state.PrintModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <div className="  modal-body">
              <div className="container-fluid ModalContainer">
                <div className="col-12">
                  <div className="row">
                    <div className="col-10">
                      <p className="poppins_medium ModalHading">
                        Print Sell Report
                      </p>
                    </div>
                    <div className="col-2 text-right">
                      <img
                        className="Hov"
                        onClick={() => this.setState({ PrintModal: false })}
                        src={CloseIcon}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <div className="row">
                    <div className="col-6">
                      <p className="poppins_medium Modaltext">Start Date </p>
                      <input
                        type="date"
                        name="fromDate"
                        onChange={this.onChange}
                        value={this.state.fromDate}
                      />
                    </div>
                    <div className="col-6 ">
                      <p className="poppins_medium Modaltext">End Date </p>
                      <input
                        type="date"
                        name="toDate"
                        onChange={this.onChange}
                        value={this.state.toDate}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 text-right mt-5 pt-5">
                  <button
                    className="PrintModalBtn"
                    onClick={() => this.getBetweenDate()}
                  >
                    Print Report
                  </button>
                </div>
              </div>
            </div>
          </Modal>
          <Modal
            dialogClassName="col-xl-12 "
            show={this.state.ReferenceModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <div className="  modal-body">
              <div className="container-fluid ModalContainer">
                <div className="col-12">
                  <div className="row">
                    <div className="col-10">
                      <p className="poppins_medium ModalHading">
                        Reference ID: {this.state.index?.ID}
                      </p>
                    </div>
                    <div className="col-2 text-right">
                      <img
                        className="Hov"
                        onClick={() => this.setState({ ReferenceModal: false })}
                        src={CloseIcon}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  {this.state.isUploading && (
                    <div className="loader-small"></div>
                  )}

                  <div className="row">
                    <div className="col-8">
                      <div className="col-12 mt-5">
                        <div className="row">
                          <div className="col-5 Vertical_center text-right">
                            <p className="poppins_medium Modaltext mb-0">
                              Author Name
                            </p>
                          </div>
                          <div className="col-7 ">
                            <input
                              className="ModalInput col-12 "
                              value={this.state.index?.paperback?.Author_Name || ''}
                              disabled={true}
                            ></input>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 mt-3">
                        <div className="row">
                          <div className="col-5 Vertical_center text-right">
                            <p className="poppins_medium Modaltext mb-0">
                              Book Name
                            </p>
                          </div>
                          <div className="col-7 ">
                            <input
                              className="ModalInput col-12 "
                              value={this.state.index?.paperback?.Name || ''}
                              disabled={true}
                            ></input>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 mt-3">
                        <div className="row">
                          <div className="col-5 Vertical_center text-right">
                            <p className="poppins_medium Modaltext">
                              Clearing Amount
                            </p>
                          </div>
                          <div className="col-7 ">
                            <input
                              className="ModalInput col-12 "
                              name="Amount"
                              onChange={this.onChangeText}
                              value={this.state.Amount}
                            ></input>
                            <label
                              style={{
                                fontSize: '10px',
                                marginTop: '1px'
                              }}
                            >
                              {this.state.clearingAmountLabel}
                            </label>
                          </div>
                        </div>
                        {errors.Amount && (
                          <div className="invaliderrorAddNewBookImageModal">
                            {errors.Amount}
                          </div>
                        )}
                      </div>
                      <div className="col-12 mt-3">
                        <div className="row">
                          <div className="col-5 Vertical_center text-right">
                            <p className="poppins_medium Modaltext mb-0">
                              Payment Status
                            </p>
                          </div>
                          <div className="col-7 ">
                            <select
                              className="ModalInput col-12 "
                              name="Status"
                              onChange={this.onChangeText}
                              value={this.state.Status}
                            >
                              <option>Select ...</option>
                              <option value="Cleared">Cleared</option>
                              <option value="Pending">Pending</option>
                              <option value="Failed">Failed</option>
                            </select>

                            {errors.Status && (
                              <div className="invaliderrorAddNewBookImageModal">
                                {errors.Status}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-12 mt-3">
                        <div className="row">
                          <div className="col-5 Vertical_center text-right">
                            <p className="poppins_medium Modaltext mb-0">
                              Reference Number
                            </p>
                          </div>
                          <div className="col-7 ">
                            <input
                              className="ModalInput col-12 "
                              name="Reference_No"
                              onChange={this.onChangeText}
                              value={this.state.Reference_No}
                            />

                            {errors.Reference_No && (
                              <div className="invaliderrorAddNewBookImageModal">
                                {errors.Reference_No}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-4  Vertical_center ">
                      <div className="col-12 mt-3">
                        <p className="poppins_medium Modaltext mb-0">
                          Any Attachment{" "}
                        </p>
                        <img
                          className="mt-3 placeholderImg"
                          src={PlaceHolder}
                        />
                      </div>
                      <div className="col-12 mt-3 text-center">
                        <button
                          className="mdlBtn col-12 poppins_semibold"
                          onClick={() => this.onPayment(this.state.index)}
                        >
                          Save Changes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>

          {/* Tracking ID Modal for Dispatched Orders */}
          <Modal
            show={this.state.trackingModal}
            onHide={this.handleTrackingModalClose}
            centered
            dialogClassName="col-sm-12"
            size="lg"
          >
            <div className="modal-body">
              <div className="container">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-4">
                  <div className="row">
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                      <p className="poppins_semibold" style={{ fontSize: '18px' }}>Enter Tracking ID</p>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 text-right">
                      <img
                        className="pointerr"
                        src={CloseIcon}
                        onClick={this.handleTrackingModalClose}
                        style={{ cursor: 'pointer', width: '20px' }}
                        alt="Close"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-4 mt-3">
                  <div className="row">
                    <div className="col-12">
                      <div className="row">
                        <div className="col-5 Vertical_center text-right">
                          <p className="poppins_medium Modaltext mb-0">
                            Tracking ID <span style={{ color: 'red' }}>*</span>
                          </p>
                        </div>
                        <div className="col-7">
                          <input
                            className="ModalInput col-12"
                            name="tracking_id"
                            placeholder="Enter tracking ID (e.g., TRACK123456789)"
                            onChange={(e) => this.setState({ tracking_id: e.target.value })}
                            value={this.state.tracking_id}
                            autoFocus
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 mt-4 text-center">
                      <button
                        className="mdlBtn col-4 poppins_semibold"
                        onClick={this.handleTrackingIdSubmit}
                        style={{ marginRight: '10px' }}
                      >
                        Dispatch Order
                      </button>
                      <button
                        className="mdlBtn col-4 poppins_semibold"
                        onClick={this.handleTrackingModalClose}
                        style={{ backgroundColor: '#6c757d', borderColor: '#6c757d' }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>

          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 managebookContainer">
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0">
                <p className="poppins_semibold managebookheading">
                  Paperback Purchase History / {this.state.author?.Full_Name}
                </p>
              </div>
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0  mt-4">
                <div className="row">
                  <div className="col-xl-4 col-lg-4 col-md-4  ">
                    <div className="SellingHistoryTopBarCard">
                      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                        <p className="EaringRs">
                          {this.state.earning == 0
                            ? "0.00"
                            : parseInt(this.state.earning * 0.7) + " RS"}
                        </p>
                        <p className="totalEaring">Total Merchant's Sale</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-4   ">
                    <div className="SellingHistoryTopBarCard">
                      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                        <p className="PendingRs">
                          {
                            this.state.clearedBills == 0 ?
                              "0.00 RS" :
                              parseInt(this.state.clearedBills) + " RS"
                          }
                        </p>
                        <p className="totalEaring">Cleared Bills</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-4  ">
                    <div className="SellingHistoryTopBarCard">
                      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
                        <p className="PendingRs1">
                          {
                            this.state.earning == 0 && this.state.clearedBills == 0 ?
                              '0.00' :
                              parseInt((this.state.earning * 0.7) - (this.state.clearedBills)) + " RS"
                          }
                        </p>
                        <p className="totalEaring">Pending Balances </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3 mb-3 managebookContainer">
          <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 3, mb: 2 }}>
            <Tabs
              value={this.state.activeTab}
              onChange={this.handleTabChange}
              sx={{
                '& .MuiTab-root': {
                  fontWeight: 'bold',
                  fontSize: '14px',
                  textTransform: 'none',
                  minWidth: 120,
                },
                '& .Mui-selected': {
                  color: '#1976d2',
                }
              }}
            >
              <Tab label="Paperback Sales" />
            </Tabs>
          </Box>
          <DataTablePaperback
            orderList={filteredOrderList}
            onChange={this.onChange}
            onSearch={this.onSearch}
            onClickFailed={this.onClickFailed}
            search={this.state.search}
            onClickActions={this.onClickActions}
            onUpdateDeliveryStatus={this.onUpdateDeliveryStatus}
          />
        </div>
      </div>
    );
  }
}

SellingHistoryPaperback.propTypes = {};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  getAllPaperbackOrders,
  createPaymentOfOrder,
  updatePaperbackOrderDelivery,
};
export default connect(mapStateToProps, mapDispatchToProps)(SellingHistoryPaperback);
